"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const AIContentStructureConstants_1 = require("./AIContentStructureConstants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.content}/v1/ai/content-structure`, {
    post: {
        [AIContentStructureConstants_1.AIContentStructureEndpointKeys.PostAIContentStructure]: '/suggestion'
    }
});
